module.exports = __webpack_public_path__ + "static/media/banner-bg.51f8e8bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/banner-bg.jpg
// module id = 496
// module chunks = 0